import ActionsForm from '@/shared/mixins/actionsForm'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import ProposalRepository from '@/shared/http/repositories/realestate/proposal'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'TableSalesConsultation',
  mixins: [ActionsForm],
  data () {
    return {
      headTable: ['CORRETOR', 'IMOBILIÁRIA', 'EMPREENDIMENTO', 'DT. DA VENDA', 'VALOR TOTAL', 'UNIDADE VENDIDA', 'PORCENTAGEM DA COMISSÃO', ''],
      consultacomissao: [],
      CredenciadaId: null,
      filterOn: false,
      ContaId: null,
      testeVariavel: []
    }
  },
  mounted () {
    this.GetUnidadeVendiada()
  },
  methods: {
    onLoad () {
      if (localStoreHelper.consulta.vendas() != null) {
        this.updateTable(localStoreHelper.consulta.vendas())
      } else {
        loading.push()
        if (this.filterOn === false) {
          CommissionRepository.GetAll(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
            .then(Response => {
              loading.pop()
              this.consultacomissao = Response.data.data
              this.$refs.tableGrid.LoadAllByData(Response)
            })
            .catch(Error => {
              loading.pop()
            })
          this.updateTable(this.credeciadaId, this.contaId)
        }
      }
    },
    GetUnidadeVendiada () {
      ProposalRepository.GetRelatorioCorretor()
        .then(Response => {
          this.testeVariavel = Response.data.data
        })
        .catch((err) => { console.log(err) })
    },
    updateTable (id, ContaId = null) {
      loading.push()
      this.CredenciadaId = id == null ? null : id.imobiliariaObj == null ? null : id.imobiliariaObj
      this.filterOn = true
      let data = {
        CredenciadaId: id == null ? null : id.imobiliariaObj == null ? null : id.imobiliariaObj,
        ContaId: id == null ? null : id.corretor == null ? null : id.corretor
      }
      CommissionRepository.GetAllByCredenciada(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, data)
        .then(Response => {
          loading.pop()
          this.consultacomissao = Response.data.data
          this.$refs.tableGrid.LoadAllByData(Response)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    toStringCus (int) {
      if (int === undefined) return '0'
      return int.toString()
    },
    updateCorretor (id) {
      this.contaId = id
      this.updateTable(this.credeciadaId, id)
    },
    searchWithFilter (newCommissionArray, newResponse) {
      this.consultacomissao = newCommissionArray
      this.$refs.tableGrid.LoadAllByData(newResponse)
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesconsultation/components/TableSalesConsultation/TableSalesConsultation.js